import React from 'react';

export default function BodyCopy(props) {
    return <div {...props} className={`prose text-grey-500 max-w-2xl ${props.className}`}>
        { props.children }
    </div>;
}
